export default __webpack_public_path__ + "static/media/foodBox.003effff.png";